/*_validate.mjs needs modification*/
export function validate() {

    const language = navigator.language || navigator.userLanguage;

    $('form.validate').submit(function (e) {

        e.preventDefault();

        var form = $(this);

        if (form.find('input[name="gender"]').length === 0) {
            alert('Honeypot field is missing...');
            return false;
        }

        if (form.find('.feedback').length === 0) {
            alert("<div> with class '.feedback' is missing...");
            return false;
        }

        var button = form.find('button[type="submit"]');
        var url = form.attr('action');
        var data = new FormData(this);
        var feedback = form.find('.feedback');
        var alert_message = feedback.find('.alert');
        var html = '';
        //var tooltip = form.find('.invalid-tooltip');

        var defaultButtonText = button.html();
        var temporaryButtonValue = '<span class="loader"></span>';

        button.html(temporaryButtonValue);

        const controls = form.find('input[name!=gender], textarea, select');

        $('.is-valid').each(function (index, value) {
            $(this).removeClass('is-valid');
        });

        $('.is-invalid').each(function (index, value) {
            $(this).removeClass('is-invalid');
        });

        //tooltip.remove();

        feedback.hide(200, function() {
            alert_message.remove();
        });

        axios.post(url, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(function (response) {

                var status = response.data.status;
                var warnings = response.data.warnings;
                var hasError = response.data.hasError;
                var message = response.data.message;

                if (response.data.redirect) {
                    window.location = response.data.redirect;
                    return false;
                }

                form.addClass('was-validated'); //uncomment and add required attribute to required fields for real-time client-side validation

                if (status === 'error') {

                    if (!Array.isArray(warnings)) {
                        warnings = [];
                    }

                    html += '<div class="alert alert-danger" role="alert"><div class="alert-heading"><svg class="feedback-icon" role="img" aria-label="Danger:"><use xlink:href="#exclamation-triangle-fill"/></svg><strong class="alert-heading">Probleem bij versturen</strong></div><hr><ul style="margin-bottom: 0;">';

                    $(controls).addClass('is-valid');

                    if (warnings.length > 0) {

                        $(warnings).each(function(index, value) {
                            html += '<li>' + value + '</li>';
                            form.find('[name="' + hasError[index] + '"]').addClass('is-invalid').removeClass('is-valid');
                        });

                    } else {
                        html += '<li>' + message + '</li>';
                    }

                    html += '</ul><button type="button" class="btn-feedback-dismiss" aria-label="Close"><svg class="dismiss-icon" role="img" aria-label="close"><use xlink:href="#dismiss"/></svg></button></div>';

                    if (typeof grecaptcha !== 'undefined' && grecaptcha) {
                        grecaptcha.reset();
                    }

                }

                if (status === 'success') {
                    html += '<div class="alert alert-success" role="alert"><div class="alert-heading"><svg class="feedback-icon" role="img" aria-label="Success:"><use xlink:href="#check-circle-fill"/></svg><strong class="alert-heading">Verstuurd!</strong></div><hr><p>' + message + '</p><button type="button" class="btn-feedback-dismiss" aria-label="Close"><svg class="dismiss-icon" role="img" aria-label="Danger:"><use xlink:href="#dismiss"/></svg></button></div>'
                }

                feedback.html(html).show(200);

                if (response.data.clear) {
                    form.trigger('reset');
                }

            })
            .catch(function (error) {
                console.log(error);
                alert('Er is iets misgegaan, neem alstublieft contact op met de beheerder!');
            });

        button.html(defaultButtonText).attr('disabled', false);

        $("[data-disclosure-control], .backdrop").on('click', function() {
            form.find('.feedback').hide(200)
            form.find('.alert').remove();
            form.removeClass('was-validated');
            form.find('.is-invalid, .is-valid').removeClass('is-invalid is-valid');
        });



    });

    $(document).on("DOMNodeInserted", ".btn-feedback-dismiss", function() {
        $(this).click(function() {
            $(this).parents('.feedback').hide(200, function() {
                $(this).find('.alert').remove();
            })
        });

    });

    $(document).on("click", ".btn-feedback-dismiss", function() {
        $(this).parents('.feedback').hide(200, function() {
            $(this).find('.alert').remove();
            $(this).closest('form').removeClass('was-validated');
            $(this).closest('form').find('.is-invalid, .is-valid').removeClass('is-invalid is-valid');
        })
    });

    $('[id^=file-input]').change(function() {
        const el = $(this);
        const files = el[0].files;
        let translation;
        let label;
        const translations = {};
        translations['en-EN'] = 'files choosen';
        translations['nl-NL'] = 'bestanden gekozen';
        if (translations[language]) {
            translation = translations[language];
        } else {
            translation = translations['en-EN'];
        }
        if (files.length > 1) {
            label = files.length + ' ' + translation;
        } else {
            label = files[0].name;
        }
        $(this).prev('label').text(label);
    });

    return 'validate';

}